export const removeSpacesFromWord = (sentence) => {
    if (!sentence) return ""
    return sentence.replace(/\s/g, '')
}